import { Chip, Skeleton } from '@heroui/react';

import { LOG_LEVEL_STYLES } from '../../constants';

type LogLevelCellProps = {
  logLevel: string;
};

export function LogLevelCell({ logLevel }: LogLevelCellProps) {
  const className = LOG_LEVEL_STYLES[logLevel] || LOG_LEVEL_STYLES.INFO;

  return (
    <Chip
      size='sm'
      className={className}
      classNames={{ content: 'text-label-md' }}
      data-testid='monitor-pipeline-logs-cell-severity'
    >
      {logLevel}
    </Chip>
  );
}

export function LogLevelCellSkeleton() {
  return <Skeleton className='h-6 w-20 rounded-full' />;
}
